import { call, put, select } from 'redux-saga/effects'
import { callApi } from '@/shared/tools/apiSagaHelper'
import { showSnackbar, SNACKBAR_TYPES } from '@/shared/tools/notifications/notification'
import { updateClubSelectra } from '@/containers/SubscriptionFormPageNew/SubscriptionForm/SubscriptionFormSlice'
import { selectPageConfigurationData } from '@/store/PageConfiguration/PageConfigurationSelectors'
import * as Sentry from '@sentry/react'

export const clubSelectraModuleActions = {
  CREATE_CLUB_SELECTRA: 'CREATE_CLUB_SELECTRA',
}

export function* createClubSelectra(action) {
  try {
    yield put(updateClubSelectra({ loading: true, success: false, error: null, message: null }))
    const { enqueue, payload } = action
    const { interaction_club_selectra_url: interactionClubSelectraUrl } = yield select(selectPageConfigurationData)

    if (!interactionClubSelectraUrl) {
      yield put(updateClubSelectra({ loading: false, success: false, error: 'Missing URL' }))
      return
    }

    const result = yield call(callApi, {
      endpoint: interactionClubSelectraUrl,
      method: 'POST',
      showErrorSnackbar: true,
      payload,
    })

    yield put(
      updateClubSelectra({
        loading: false,
        success: true,
        message: result?.message || null,
        error: null,
      }),
    )

    yield call(showSnackbar, enqueue, {
      type: SNACKBAR_TYPES.SUCCESS,
      message: result?.message || 'Club Selectra sent successfully',
    })
  } catch (error) {
    const data = error?.responseData
    const backendMessage =
      typeof data?.error === 'string' && data.error.trim()
        ? data.error
        : typeof data?.message === 'string' && data.message.trim()
          ? data.message
          : error?.message || 'Club Selectra sent error'

    yield put(
      updateClubSelectra({
        loading: false,
        success: false,
        error: backendMessage,
        message: null,
      }),
    )

    yield call(showSnackbar, action.enqueue, {
      type: SNACKBAR_TYPES.ERROR,
      message: backendMessage,
    })

    const status = error?.status || 'unknown'
    if (import.meta.env.PROD && status !== 422) {
      Sentry.captureException(new Error('Error creating club selectra'), { extra: { error } })
    }
  }
}
